import get from 'lodash/get'

const isNoCampaignsError = (error) => {
	const code = get(error, 'response.body.code')
	if ('no-campaigns-error' === code) {
		return true
	}

	if (
		'omapp_rest_error' === code &&
		'no-campaigns-error' === get(error, 'response.body.data.type')
	) {
		return true
	}

	return error
}
export default isNoCampaignsError
